import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-superfeo-gray via-white to-superfeo-lightpink/30 py-8">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-superfeo-pink mb-4 tracking-wide">
            PRIVACY POLICY
          </h1>
          <p className="text-lg text-superfeo-darkgray font-body">Last updated: April 24, 2026</p>
        </div>

        <div className="space-y-5">
          <section className="bg-white rounded-xl shadow-lg border border-superfeo-lightpink p-6">
            <h2 className="text-2xl font-heading font-bold text-superfeo-pink mb-2">1. Information We Collect</h2>
            <p className="text-superfeo-darkgray font-body">
              We may collect booking and contact details including your name, phone number, email address, route, and travel information.
            </p>
          </section>

          <section className="bg-white rounded-xl shadow-lg border border-superfeo-lightpink p-6">
            <h2 className="text-2xl font-heading font-bold text-superfeo-pink mb-2">2. How We Use Information</h2>
            <ul className="list-disc pl-6 space-y-1 text-superfeo-darkgray font-body">
              <li>To process and manage bookings.</li>
              <li>To provide travel and support updates.</li>
              <li>To improve customer experience and service quality.</li>
              <li>To comply with legal obligations.</li>
            </ul>
          </section>

          <section className="bg-white rounded-xl shadow-lg border border-superfeo-lightpink p-6">
            <h2 className="text-2xl font-heading font-bold text-superfeo-pink mb-2">3. Data Sharing</h2>
            <p className="text-superfeo-darkgray font-body">
              We share data only when required for service delivery, legal compliance, or with your consent.
            </p>
          </section>

          <section className="bg-white rounded-xl shadow-lg border border-superfeo-lightpink p-6">
            <h2 className="text-2xl font-heading font-bold text-superfeo-pink mb-2">4. Contact</h2>
            <p className="text-superfeo-darkgray font-body">
              For privacy requests, email{' '}
              <a href="mailto:privacy@superfeoexpress.co.tz" className="text-superfeo-pink hover:underline">
                privacy@superfeoexpress.co.tz
              </a>
              .
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
